/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import Button from "components/CustomButtons/Button.js";
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TSText from "components/Forms/TSText";
import TSSelect2 from "components/Forms/TSSelect2";
import TSCheckBox from "components/Forms/TSCheckBox";
import Datetime from "react-datetime";
import { Label, Input, InputGroup, InputGroupAddon, InputGroupText, Modal, ModalBody } from "reactstrap";
import "react-datetime/css/react-datetime.css";

const useStyles = makeStyles(() => ({
  cardCategoryWhite: {
    color: "rgba(255,255,255,.85)",
    margin: "0",
    fontSize: "14px",
    marginTop: "4px",
    marginBottom: "0",
    fontFamily: '"Sarabun", sans-serif',
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "600",
    fontSize: "1.35rem",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "2px",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  sectionTitle: {
    borderBottom: "2px solid #e91e63",
    paddingBottom: "8px",
    marginBottom: "18px",
    marginTop: "20px",
    fontFamily: '"Sarabun", sans-serif',
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "8px",
    "&:first-child": {
      marginTop: "5px",
    },
  },
  sectionTitleText: {
    fontFamily: '"Sarabun", sans-serif',
    fontSize: "1.08rem",
    fontWeight: "700",
    color: "#3C4858",
    margin: 0,
  },
  sectionSubText: {
    fontFamily: '"Sarabun", sans-serif',
    fontSize: "0.85rem",
    color: "#777",
    margin: 0,
    fontWeight: "normal",
  },
  errorItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    color: "#c2185b",
    marginBottom: "8px",
    fontSize: "0.95rem",
    fontFamily: '"Sarabun", sans-serif',
    background: "#fce4ec",
    padding: "10px 14px",
    borderRadius: "6px",
    borderLeft: "4px solid #e91e63",
  },
  passHintBadge: {
    fontSize: "0.8rem",
    padding: "3px 10px",
    borderRadius: "15px",
    fontFamily: '"Sarabun", sans-serif',
    fontWeight: "500",
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    transition: "all 0.2s ease",
  },
}));

// ฟังก์ชันตรวจสอบความถูกต้องของเลขประจำตัวประชาชนไทย 13 หลัก (Checksum)
const validateThaiCitizenId = (id) => {
  if (!id || typeof id !== "string") return false;
  const cleanId = id.trim().replace(/[-\s]/g, "");
  if (!/^\d{13}$/.test(cleanId)) return false;

  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += parseInt(cleanId.charAt(i), 10) * (13 - i);
  }
  const checkDigit = (11 - (sum % 11)) % 10;
  return checkDigit === parseInt(cleanId.charAt(12), 10);
};

const titleOptions = [
  { label: "นาย", value: "นาย" },
  { label: "นาง", value: "นาง" },
  { label: "นางสาว", value: "นางสาว" },
  { label: "นพ.", value: "นพ." },
  { label: "พญ.", value: "พญ." },
  { label: "ทพ.", value: "ทพ." },
  { label: "ทพญ.", value: "ทพญ." },
  { label: "ภก.", value: "ภก." },
  { label: "ภญ.", value: "ภญ." },
  { label: "ดร.", value: "ดร." },
  { label: "อาจารย์", value: "อาจารย์" },
];

const genderList = [
  { label: "ชาย", value: 1 },
  { label: "หญิง", value: 2 },
];

const UserRequest = () => {
  const classes = useStyles();
  const history = useHistory();
  const moment = require("moment");
  require("moment/locale/th");

  // State ฟอร์ม - หมวดที่ 1: ข้อมูลบัญชีผู้ใช้
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // State ฟอร์ม - หมวดที่ 2: ข้อมูลส่วนบุคคล
  const [titleName, setTitleName] = useState("");
  const [customTitle, setCustomTitle] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [nickName, setNickName] = useState("");
  const [cid, setCid] = useState("");
  const [genderKey, setGenderKey] = useState(0);
  const [birthDT, setBirthDT] = useState("");
  const [isShowBirthdate, setIsShowBirthdate] = useState(false);

  // State ฟอร์ม - หมวดที่ 3: ข้อมูลการติดต่อ
  const [mobilePhone, setMobilePhone] = useState("");
  const [email, setEmail] = useState("");
  const [gmail, setGmail] = useState("");
  const [address, setAddress] = useState("");

  // State สำหรับ Modal และการประมวลผล
  const [errors, setErrors] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [modalConfirm, setModalConfirm] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successInfo, setSuccessInfo] = useState(null);

  // State สำหรับเช็ค Username ซ้ำแบบ Real-time
  const [usernameStatus, setUsernameStatus] = useState({ checking: false, available: null, msg: "" });

  const cleanUserName = userName.trim();

  // ตรวจสอบ Username ซ้ำแบบ Real-time ด้วย Debounce 500ms
  useEffect(() => {
    if (!cleanUserName || cleanUserName.length < 3 || /\s/.test(cleanUserName) || !/^[a-zA-Z0-9_\.\-]+$/.test(cleanUserName)) {
      setUsernameStatus({ checking: false, available: null, msg: "" });
      return;
    }

    setUsernameStatus({ checking: true, available: null, msg: "" });
    const timer = setTimeout(() => {
      axios
        .get(`/api/v1/user/check-username?username=${encodeURIComponent(cleanUserName)}`)
        .then((res) => {
          if (res.data) {
            setUsernameStatus({
              checking: false,
              available: Boolean(res.data.isAvailable),
              msg: res.data.msg || "",
            });
          }
        })
        .catch(() => {
          setUsernameStatus({ checking: false, available: null, msg: "" });
        });
    }, 500);

    return () => clearTimeout(timer);
  }, [cleanUserName]);

  // เช็คเงื่อนไข Password แบบ Real-time
  const hasValidLength = password.length >= 8 && password.length <= 20;
  const hasLowerCase = /[a-z]/.test(password);
  const hasUpperCase = /[A-Z]/.test(password);
  const isPasswordMatch = password && confirmPassword && password === confirmPassword;

  // เช็คเงื่อนไข เลขบัตรประชาชนแบบ Real-time
  const cleanCid = cid.trim().replace(/[-\s]/g, "");
  const isCidFormatValid = cleanCid.length === 13 && /^\d{13}$/.test(cleanCid);
  const isCidChecksumValid = isCidFormatValid && validateThaiCitizenId(cleanCid);

  const handleResetForm = () => {
    setUserName("");
    setPassword("");
    setConfirmPassword("");
    setShowPassword(false);
    setShowConfirmPassword(false);
    setTitleName("");
    setCustomTitle("");
    setFirstName("");
    setLastName("");
    setNickName("");
    setCid("");
    setGenderKey(0);
    setBirthDT("");
    setIsShowBirthdate(false);
    setMobilePhone("");
    setEmail("");
    setGmail("");
    setAddress("");
    setErrors([]);
    setUsernameStatus({ checking: false, available: null, msg: "" });
    setModalSuccess(false);
  };

  const getEffectiveTitle = () => {
    if (titleName === "custom") return customTitle.trim();
    return titleName;
  };

  // ตรวจสอบความถูกต้องและครบถ้วนของข้อมูล
  const handleValidate = (e) => {
    if (e) e.preventDefault();
    const errList = [];

    // 1. ตรวจสอบ Username
    if (!cleanUserName) {
      errList.push("กรุณาระบุชื่อผู้ใช้งาน (Username)");
    } else if (/\s/.test(cleanUserName)) {
      errList.push("Username ต้องไม่มีช่องว่าง");
    } else if (!/^[a-zA-Z0-9_\.\-]+$/.test(cleanUserName)) {
      errList.push(
        "Username ต้องประกอบด้วยตัวอักษรภาษาอังกฤษ ตัวเลข หรืออักขระ _ . - เท่านั้น"
      );
    } else if (cleanUserName.length < 3) {
      errList.push("Username ต้องมีความยาวอย่างน้อย 3 ตัวอักษร");
    } else if (usernameStatus.available === false) {
      errList.push(usernameStatus.msg || "ชื่อผู้ใช้งานนี้มีอยู่ในระบบแล้ว กรุณาเลือกชื่ออื่น");
    }

    // 2. ตรวจสอบ Password (ความยาว 8 ตัวขึ้นไป และบังคับมีตัวเล็ก-ใหญ่)
    if (!password) {
      errList.push("กรุณาระบุรหัสผ่าน");
    } else if (password.length < 8) {
      errList.push("รหัสผ่านต้องมีความยาวอย่างน้อย 8 ตัวอักษร");
    } else if (!/[a-z]/.test(password)) {
      errList.push("รหัสผ่านต้องมีตัวอักษรภาษาอังกฤษพิมพ์เล็ก (a-z) อย่างน้อย 1 ตัว");
    } else if (!/[A-Z]/.test(password)) {
      errList.push("รหัสผ่านต้องมีตัวอักษรภาษาอังกฤษพิมพ์ใหญ่ (A-Z) อย่างน้อย 1 ตัว");
    }

    // 3. ตรวจสอบ Confirm Password
    if (!confirmPassword) {
      errList.push("กรุณายืนยันรหัสผ่าน");
    } else if (password !== confirmPassword) {
      errList.push("รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน");
    }

    // 4. ตรวจสอบคำนำหน้าชื่อ
    const effTitle = getEffectiveTitle();
    if (!effTitle) {
      errList.push("กรุณาเลือกหรือระบุคำนำหน้าชื่อ");
    }

    // 5. ตรวจสอบชื่อและนามสกุล
    if (!firstName.trim()) {
      errList.push("กรุณาระบุชื่อจริง (ภาษาไทย)");
    }
    if (!lastName.trim()) {
      errList.push("กรุณาระบุนามสกุล (ภาษาไทย)");
    }

    // 6. ตรวจสอบเลขประจำตัวประชาชน (Cid)
    if (!cleanCid) {
      errList.push("กรุณาระบุเลขประจำตัวประชาชน 13 หลัก");
    } else if (cleanCid.length !== 13 || !/^\d{13}$/.test(cleanCid)) {
      errList.push("เลขประจำตัวประชาชนต้องเป็นตัวเลขครบ 13 หลัก");
    } else if (!validateThaiCitizenId(cleanCid)) {
      errList.push("เลขประจำตัวประชาชนไม่ถูกต้องตามรูปแบบการคำนวณของกรมการปกครอง (Checksum ไม่ผ่าน)");
    }

    // 7. ตรวจสอบเพศ
    if (!genderKey || genderKey === 0) {
      errList.push("กรุณาเลือกเพศ");
    }

    // 8. ตรวจสอบ Email (ถ้ากรอก)
    if (email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      errList.push("รูปแบบ Email ภายในไม่ถูกต้อง (เช่น example@trangskin.go.th)");
    }

    // 9. ตรวจสอบ Gmail (ถ้ากรอก)
    if (gmail.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(gmail.trim())) {
      errList.push("รูปแบบ Gmail ไม่ถูกต้อง (เช่น user@gmail.com)");
    }

    // 10. ตรวจสอบเบอร์โทรศัพท์ (ถ้ากรอก)
    const cleanPhone = mobilePhone.trim().replace(/[-\s]/g, "");
    if (cleanPhone && !/^\d{9,10}$/.test(cleanPhone)) {
      errList.push("เบอร์โทรศัพท์มือถือต้องเป็นตัวเลข 9-10 หลัก");
    }

    if (errList.length > 0) {
      setErrors(errList);
      setModalError(true);
    } else {
      setModalConfirm(true);
    }
  };

  // ส่งข้อมูลไปยัง API (บันทึกลง AspNetUsers และ UserProfile เท่านั้น ไม่สร้าง UserDepartment)
  const handleConfirmSubmit = () => {
    setIsSubmitting(true);

    const payload = {
      userName: cleanUserName,
      password: password,
      titleName: getEffectiveTitle(),
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      nickName: nickName.trim(),
      cid: cleanCid,
      genderKey: Number(genderKey),
      birthDT: birthDT && moment(birthDT).isValid() ? moment(birthDT).format("YYYY-MM-DD") : null,
      isShowBirthdate: Boolean(isShowBirthdate),
      mobilePhone: mobilePhone.trim(),
      email: email.trim(),
      gmail: gmail.trim(),
      address: address.trim(),
      isActive: true,
    };

    axios
      .post("/api/v1/user/create", payload)
      .then((res) => {
        setIsSubmitting(false);
        setModalConfirm(false);
        if (res.data && res.data.result === 200) {
          setSuccessInfo(res.data.data || { userName: payload.userName, fullName: `${payload.titleName} ${payload.firstName} ${payload.lastName}` });
          setModalSuccess(true);
        } else {
          setErrors([res.data?.msg || "ไม่สามารถสร้างผู้ใช้งานได้"]);
          setModalError(true);
        }
      })
      .catch((err) => {
        setIsSubmitting(false);
        setModalConfirm(false);
        const errMsg =
          err.response?.data?.msg ||
          err.response?.data?.Errors?.join(", ") ||
          err.message ||
          "เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์";
        setErrors([errMsg]);
        setModalError(true);
      });
  };

  return (
    <div>
      <Grid>
        <Col xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>
                <i className="fas fa-user-plus" style={{ fontSize: "1.25rem", marginRight: "8px" }}></i>
                แบบคำขอรหัสเข้าใช้งานระบบ (สร้าง User ใหม่)
              </h4>
              <p className={classes.cardCategoryWhite}>
                กรอกข้อมูลบัญชีผู้ใช้และข้อมูลประวัติส่วนบุคคลเพื่อเปิดสิทธิ์การเข้าใช้งานระบบสารสนเทศโรงพยาบาล
              </p>
            </CardHeader>

            <CardBody style={{ padding: "24px 20px" }}>
              {/* หมวดที่ 1: ข้อมูลบัญชีผู้ใช้ */}
              <div className={classes.sectionTitle}>
                <i className="fas fa-user-shield" style={{ color: "#e91e63", fontSize: "1.15rem" }}></i>
                <h5 className={classes.sectionTitleText}>1. ข้อมูลบัญชีผู้ใช้งาน (สำหรับล็อกอินเข้าระบบ)</h5>
                <span className={classes.sectionSubText}>กำหนดชื่อบัญชี (Username) และรหัสผ่านสำหรับการเข้าสู่ระบบ</span>
              </div>

              <Grid>
                <Col xs={12} sm={12} md={4}>
                  <TSText
                    label="ชื่อผู้ใช้งาน (Username) *"
                    icon="fas fa-user-circle"
                    placeholder="เช่น somchai.p (ภาษาอังกฤษ/ตัวเลข)"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                  />

                  {/* แสดงสถานะการตรวจสอบ Username ซ้ำแบบ Real-time */}
                  {cleanUserName.length >= 3 && usernameStatus.checking && (
                    <div
                      style={{
                        marginTop: "6px",
                        fontSize: "0.82rem",
                        fontFamily: '"Sarabun", sans-serif',
                        color: "#777",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <i className="fas fa-spinner fa-spin"></i>
                      <span>กำลังตรวจสอบชื่อผู้ใช้งาน...</span>
                    </div>
                  )}
                  {cleanUserName.length >= 3 && !usernameStatus.checking && usernameStatus.available === true && (
                    <div
                      style={{
                        marginTop: "6px",
                        fontSize: "0.82rem",
                        fontFamily: '"Sarabun", sans-serif',
                        color: "#2e7d32",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        fontWeight: "500",
                      }}
                    >
                      <i className="fas fa-check-circle"></i>
                      <span>Username นี้สามารถใช้งานได้</span>
                    </div>
                  )}
                  {cleanUserName.length >= 3 && !usernameStatus.checking && usernameStatus.available === false && (
                    <div
                      style={{
                        marginTop: "6px",
                        fontSize: "0.82rem",
                        fontFamily: '"Sarabun", sans-serif',
                        color: "#d32f2f",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        fontWeight: "500",
                      }}
                    >
                      <i className="fas fa-times-circle"></i>
                      <span>{usernameStatus.msg || "ชื่อผู้ใช้งานนี้มีอยู่ในระบบแล้ว"}</span>
                    </div>
                  )}
                </Col>
                <Col xs={12} sm={12} md={4}>
                  <div style={{ position: "relative" }}>
                    <TSText
                      label="รหัสผ่าน (Password) *"
                      type={showPassword ? "text" : "password"}
                      icon="fas fa-lock"
                      placeholder="อย่างน้อย 8 ตัวอักษร (A-Z และ a-z)"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "34px",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "#777",
                        zIndex: 2,
                        padding: "4px",
                      }}
                      title={showPassword ? "ซ่อนรหัสผ่าน" : "แสดงรหัสผ่าน"}
                    >
                      <i className={showPassword ? "far fa-eye-slash" : "far fa-eye"}></i>
                    </button>
                  </div>

                  {/* แสดงสถานะความถูกต้องของรหัสผ่านแบบ Real-time */}
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "8px" }}>
                    <span
                      className={classes.passHintBadge}
                      style={{
                        background: hasValidLength ? "#e8f5e9" : "#f5f5f5",
                        color: hasValidLength ? "#2e7d32" : "#757575",
                      }}
                    >
                      <i className={hasValidLength ? "fas fa-check-circle" : "far fa-circle"} style={{ fontSize: "0.75rem" }}></i>
                      อย่างน้อย 8 ตัว
                    </span>
                    <span
                      className={classes.passHintBadge}
                      style={{
                        background: hasLowerCase ? "#e8f5e9" : "#f5f5f5",
                        color: hasLowerCase ? "#2e7d32" : "#757575",
                      }}
                    >
                      <i className={hasLowerCase ? "fas fa-check-circle" : "far fa-circle"} style={{ fontSize: "0.75rem" }}></i>
                      ตัวพิมพ์เล็ก (a-z)
                    </span>
                    <span
                      className={classes.passHintBadge}
                      style={{
                        background: hasUpperCase ? "#e8f5e9" : "#f5f5f5",
                        color: hasUpperCase ? "#2e7d32" : "#757575",
                      }}
                    >
                      <i className={hasUpperCase ? "fas fa-check-circle" : "far fa-circle"} style={{ fontSize: "0.75rem" }}></i>
                      ตัวพิมพ์ใหญ่ (A-Z)
                    </span>
                  </div>
                </Col>
                <Col xs={12} sm={12} md={4}>
                  <div style={{ position: "relative" }}>
                    <TSText
                      label="ยืนยันรหัสผ่าน (Confirm Password) *"
                      type={showConfirmPassword ? "text" : "password"}
                      icon="fas fa-shield-alt"
                      placeholder="พิมพ์รหัสผ่านซ้ำอีกครั้ง"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "34px",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "#777",
                        zIndex: 2,
                        padding: "4px",
                      }}
                      title={showConfirmPassword ? "ซ่อนรหัสผ่าน" : "แสดงรหัสผ่าน"}
                    >
                      <i className={showConfirmPassword ? "far fa-eye-slash" : "far fa-eye"}></i>
                    </button>
                  </div>

                  {/* แสดงสถานะยืนยันรหัสผ่าน */}
                  {confirmPassword && (
                    <div
                      style={{
                        marginTop: "8px",
                        fontSize: "0.82rem",
                        fontFamily: '"Sarabun", sans-serif',
                        color: isPasswordMatch ? "#2e7d32" : "#d32f2f",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        fontWeight: "500",
                      }}
                    >
                      <i className={isPasswordMatch ? "fas fa-check-circle" : "fas fa-times-circle"}></i>
                      <span>{isPasswordMatch ? "รหัสผ่านตรงกันสมบูรณ์" : "รหัสผ่านยังไม่ตรงกัน"}</span>
                    </div>
                  )}
                </Col>
              </Grid>

              {/* หมวดที่ 2: ข้อมูลส่วนบุคคล */}
              <div className={classes.sectionTitle}>
                <i className="fas fa-id-card" style={{ color: "#e91e63", fontSize: "1.15rem" }}></i>
                <h5 className={classes.sectionTitleText}>2. ข้อมูลส่วนบุคคล</h5>
                <span className={classes.sectionSubText}>ข้อมูลคำนำหน้า ชื่อ-นามสกุล เลขประจำตัวประชาชน และวันเกิดของเจ้าหน้าที่</span>
              </div>

              <Grid>
                <Col xs={12} sm={6} md={3}>
                  <TSSelect2
                    label="คำนำหน้าชื่อ *"
                    options={[
                      ...titleOptions,
                      { label: "ระบุเอง...", value: "custom" },
                    ]}
                    value={titleName}
                    onChange={(e) => setTitleName(e ? e.value : "")}
                  />
                  {titleName === "custom" && (
                    <div style={{ marginTop: "8px" }}>
                      <TSText
                        label="ระบุคำนำหน้าชื่อ"
                        icon="fas fa-tag"
                        placeholder="เช่น ดร., พ.ต.อ."
                        value={customTitle}
                        onChange={(e) => setCustomTitle(e.target.value)}
                      />
                    </div>
                  )}
                </Col>
                <Col xs={12} sm={6} md={3}>
                  <TSText
                    label="ชื่อจริง (ภาษาไทย) *"
                    icon="fas fa-user"
                    placeholder="ชื่อจริง"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </Col>
                <Col xs={12} sm={6} md={3}>
                  <TSText
                    label="นามสกุล (ภาษาไทย) *"
                    icon="fas fa-user"
                    placeholder="นามสกุล"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </Col>
                <Col xs={12} sm={6} md={3}>
                  <TSText
                    label="ชื่อเล่น"
                    icon="far fa-smile"
                    placeholder="ชื่อเล่น"
                    value={nickName}
                    onChange={(e) => setNickName(e.target.value)}
                  />
                </Col>
              </Grid>

              <Grid style={{ marginTop: "12px" }}>
                <Col xs={12} sm={6} md={4}>
                  <TSText
                    label="เลขประจำตัวประชาชน (13 หลัก) *"
                    icon="far fa-id-card"
                    placeholder="ตัวเลข 13 หลัก ไม่ต้องใส่ขีด"
                    maxLength={13}
                    value={cid}
                    onChange={(e) => setCid(e.target.value.replace(/\D/g, ""))}
                  />
                  {cleanCid.length === 13 && (
                    <div
                      style={{
                        marginTop: "6px",
                        fontSize: "0.82rem",
                        fontFamily: '"Sarabun", sans-serif',
                        color: isCidChecksumValid ? "#2e7d32" : "#d32f2f",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        fontWeight: "500",
                      }}
                    >
                      <i className={isCidChecksumValid ? "fas fa-check-circle" : "fas fa-exclamation-circle"}></i>
                      <span>
                        {isCidChecksumValid
                          ? "เลขบัตรประชาชนถูกต้องตามหลักคำนวณ"
                          : "เลขบัตรประชาชนไม่ถูกต้อง (Checksum ไม่ผ่าน)"}
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={12} sm={6} md={4}>
                  <TSSelect2
                    label="เพศ *"
                    options={genderList}
                    value={genderKey}
                    onChange={(e) => setGenderKey(e ? e.value : 0)}
                  />
                </Col>
                <Col xs={12} sm={12} md={4}>
                  <Label style={{ fontFamily: '"Sarabun", sans-serif', fontSize: "0.95rem", marginBottom: "6px" }}>
                    วันเดือนปีเกิด
                  </Label>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText style={{ borderRadius: "0", padding: "10px 12px", background: "#f8fafc", borderColor: "#cbd5e1" }}>
                        <i className="far fa-calendar-alt" style={{ color: "#e91e63" }}></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Datetime
                      value={birthDT && moment(birthDT).isValid() ? moment(birthDT) : null}
                      renderYear={(props, year) => <td {...props}>{year + 543}</td>}
                      inputProps={{
                        name: "BirthDT",
                        placeholder: "เลือกวันเดือนปีเกิด",
                        readOnly: true,
                        style: {
                          borderRadius: "0",
                          cursor: "pointer",
                          background: "#ffffff",
                          color: "#1e293b",
                          fontFamily: '"Sarabun", sans-serif',
                          height: "44px",
                          borderColor: "#cbd5e1",
                        },
                        value:
                          birthDT && moment(birthDT).isValid()
                            ? moment(birthDT).format("D MMMM BBBB")
                            : "",
                      }}
                      closeOnSelect={true}
                      dateFormat="D MMMM BBBB"
                      timeFormat={false}
                      onChange={(e) => {
                        if (moment.isMoment(e)) {
                          setBirthDT(e.format("YYYY-MM-DD"));
                        } else if (typeof e === "string") {
                          setBirthDT(e);
                        }
                      }}
                    />
                  </InputGroup>
                  <div style={{ marginTop: "6px" }}>
                    <TSCheckBox
                      checked={isShowBirthdate}
                      onChange={() => setIsShowBirthdate(!isShowBirthdate)}
                    />
                    <span style={{ fontSize: "0.88rem", color: isShowBirthdate ? "#2e7d32" : "#777", fontFamily: '"Sarabun", sans-serif' }}>
                      {isShowBirthdate ? " แสดงวันเกิดในปฏิทิน" : " ไม่แสดงวันเกิดในปฏิทิน"}
                    </span>
                  </div>
                </Col>
              </Grid>

              {/* หมวดที่ 3: ข้อมูลการติดต่อ */}
              <div className={classes.sectionTitle}>
                <i className="fas fa-address-book" style={{ color: "#e91e63", fontSize: "1.15rem" }}></i>
                <h5 className={classes.sectionTitleText}>3. ข้อมูลการติดต่อ</h5>
                <span className={classes.sectionSubText}>เบอร์โทรศัพท์มือถือ อีเมลภายใน บัญชี Gmail และที่อยู่สำหรับติดต่อราชการ</span>
              </div>

              <Grid>
                <Col xs={12} sm={6} md={4}>
                  <TSText
                    label="เบอร์โทรศัพท์มือถือ"
                    icon="fas fa-phone-alt"
                    placeholder="เช่น 0812345678"
                    maxLength={10}
                    value={mobilePhone}
                    onChange={(e) => setMobilePhone(e.target.value.replace(/\D/g, ""))}
                  />
                </Col>
                <Col xs={12} sm={6} md={4}>
                  <TSText
                    label="อีเมลภายใน (Email)"
                    icon="fas fa-envelope"
                    placeholder="user@trangskin.go.th"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Col>
                <Col xs={12} sm={6} md={4}>
                  <TSText
                    label="บัญชี Gmail"
                    icon="fab fa-google"
                    placeholder="user@gmail.com"
                    value={gmail}
                    onChange={(e) => setGmail(e.target.value)}
                  />
                </Col>
                <Col xs={12} sm={12} md={12} style={{ marginTop: "12px" }}>
                  <Label for="userAddress" style={{ fontFamily: '"Sarabun", sans-serif', fontSize: "0.95rem", marginBottom: "6px" }}>
                    <i className="fas fa-map-marker-alt" style={{ marginRight: "6px", color: "#e91e63" }}></i>
                    ที่อยู่ปัจจุบัน
                  </Label>
                  <Input
                    id="userAddress"
                    name="Address"
                    placeholder="ระบุที่อยู่ปัจจุบัน..."
                    rows="3"
                    type="textarea"
                    style={{ fontSize: "1rem", fontFamily: '"Sarabun", sans-serif', borderRadius: "4px", borderColor: "#cbd5e1" }}
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </Col>
              </Grid>

              {/* ข้อชี้แจงการกำหนดตำแหน่งและการจัดสังกัด */}
              <div
                style={{
                  padding: "14px 18px",
                  background: "#fce4ec",
                  borderLeft: "4px solid #e91e63",
                  borderRadius: "4px",
                  fontSize: "0.92rem",
                  color: "#880e4f",
                  fontFamily: '"Sarabun", sans-serif',
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "12px",
                  marginTop: "24px",
                  marginBottom: "8px",
                }}
              >
                <i className="fas fa-info-circle fa-lg" style={{ color: "#e91e63", marginTop: "3px", flexShrink: 0 }}></i>
                <div style={{ lineHeight: "1.6" }}>
                  <strong>ข้อชี้แจง:</strong> ระบบจะบันทึกบัญชีสำหรับเข้าสู่ระบบ (Identity) และข้อมูลประวัติส่วนบุคคลเท่านั้น ทั้งนี้ <strong>ข้อมูลตำแหน่งหน้าที่ ประเภทการจ้างงาน และกลุ่มงาน/ฝ่าย/สังกัด (UserDepartment)</strong> เจ้าหน้าที่ฝ่ายทรัพยากรบุคคลสามารถไปกำหนดเพิ่มเติมได้ที่หน้าเมนู <strong>"ข้อมูลเจ้าหน้าที่"</strong> หลังเสร็จสิ้นการสร้างผู้ใช้
                </div>
              </div>
            </CardBody>

            <CardFooter style={{ justifyContent: "center", gap: "16px", paddingTop: "14px", paddingBottom: "24px" }}>
              <Button
                color="primary"
                onClick={handleValidate}
                style={{
                  minWidth: "150px",
                  fontFamily: '"Sarabun", sans-serif',
                }}
              >
                <i className="fas fa-save" style={{ marginRight: "8px" }}></i>
                <h4>บันทึก</h4>
              </Button>
              <Button
                color="danger"
                onClick={handleResetForm}
                style={{
                  minWidth: "120px",
                  fontFamily: '"Sarabun", sans-serif',
                }}
              >
                <i className="fas fa-undo" style={{ marginRight: "8px" }}></i>
                <h4>ล้างข้อมูล</h4>
              </Button>
            </CardFooter>
          </Card>
        </Col>
      </Grid>

      {/* Modal 1: Error Notification Dialog */}
      <Modal toggle={() => setModalError(false)} isOpen={modalError} centered>
        <div className="modal-header justify-content-center" style={{ borderBottom: "none", paddingTop: "24px" }}>
          <i className="fa fa-times" style={{ color: "#f44336", fontSize: "2.8rem" }}></i>
        </div>
        <ModalBody style={{ padding: "10px 24px 20px" }}>
          <h4 style={{ textAlign: "center", color: "#c2185b", fontFamily: '"Sarabun", sans-serif', fontWeight: "bold", fontSize: "1.15rem", marginBottom: "16px" }}>
            พบข้อผิดพลาดในการกรอกข้อมูล
          </h4>
          <p style={{ fontFamily: '"Sarabun", sans-serif', color: "#555", marginBottom: "12px", fontSize: "0.92rem" }}>
            กรุณาตรวจสอบและแก้ไขข้อมูลดังต่อไปนี้:
          </p>
          <div style={{ maxHeight: "300px", overflowY: "auto" }}>
            {errors.map((msg, index) => (
              <div key={index} className={classes.errorItem}>
                <i className="fas fa-times-circle" style={{ color: "#e91e63", marginTop: "3px", flexShrink: 0 }}></i>
                <span>{msg}</span>
              </div>
            ))}
          </div>
        </ModalBody>
        <div className="modal-footer justify-content-center" style={{ borderTop: "none", paddingBottom: "20px" }}>
          <Button color="primary" onClick={() => setModalError(false)} style={{ minWidth: "110px", fontFamily: '"Sarabun", sans-serif' }}>
            <h4>ตกลง</h4>
          </Button>
        </div>
      </Modal>

      {/* Modal 2: Confirm Dialog */}
      <Modal toggle={() => !isSubmitting && setModalConfirm(false)} isOpen={modalConfirm} centered>
        <div className="modal-header justify-content-center" style={{ borderBottom: "none", paddingTop: "24px" }}>
          <i className="fas fa-question-circle" style={{ color: "#e91e63", fontSize: "2.8rem" }}></i>
        </div>
        <ModalBody style={{ textAlign: "center", padding: "10px 24px" }}>
          <h4 style={{ fontFamily: '"Sarabun", sans-serif', fontWeight: "bold", color: "#3C4858", marginBottom: "12px" }}>
            ยืนยันการสร้างบัญชีผู้ใช้งาน
          </h4>
          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eeeeee",
              borderRadius: "6px",
              padding: "16px",
              textAlign: "left",
              fontFamily: '"Sarabun", sans-serif',
              marginBottom: "12px",
            }}
          >
            <div style={{ marginBottom: "8px", display: "flex", alignItems: "center", gap: "8px" }}>
              <i className="fas fa-user-circle" style={{ color: "#e91e63", width: "18px" }}></i>
              <span>Username: <strong style={{ color: "#e91e63" }}>{cleanUserName}</strong></span>
            </div>
            <div style={{ marginBottom: "8px", display: "flex", alignItems: "center", gap: "8px" }}>
              <i className="fas fa-user" style={{ color: "#3C4858", width: "18px" }}></i>
              <span>ชื่อ-นามสกุล: <strong>{getEffectiveTitle()} {firstName.trim()} {lastName.trim()}</strong></span>
            </div>
            <div style={{ marginBottom: "8px", display: "flex", alignItems: "center", gap: "8px" }}>
              <i className="fas fa-id-card" style={{ color: "#3C4858", width: "18px" }}></i>
              <span>เลขบัตรประชาชน: <strong>{cleanCid.replace(/(\d{1})(\d{4})(\d{5})(\d{2})(\d{1})/, "$1-$2-$3-$4-$5")}</strong></span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <i className="fas fa-venus-mars" style={{ color: "#777", width: "18px" }}></i>
              <span>เพศ: <strong>{genderKey === 1 ? "ชาย" : "หญิง"}</strong></span>
            </div>
          </div>
          <p style={{ fontFamily: '"Sarabun", sans-serif', color: "#777", fontSize: "0.92rem", margin: 0 }}>
            ต้องการบันทึกข้อมูลเพื่อเปิดสิทธิ์เข้าใช้งานใช่หรือไม่?
          </p>
        </ModalBody>
        <div className="modal-footer justify-content-center" style={{ borderTop: "none", gap: "12px", paddingBottom: "24px" }}>
          <Button
            color="primary"
            onClick={handleConfirmSubmit}
            disabled={isSubmitting}
            style={{ minWidth: "120px", fontFamily: '"Sarabun", sans-serif' }}
          >
            {isSubmitting ? (
              <>
                <i className="fas fa-spinner fa-spin" style={{ marginRight: "6px" }}></i> กำลังบันทึก...
              </>
            ) : (
              <h4>ยืนยัน</h4>
            )}
          </Button>
          <Button
            color="danger"
            onClick={() => setModalConfirm(false)}
            disabled={isSubmitting}
            style={{ minWidth: "100px", fontFamily: '"Sarabun", sans-serif' }}
          >
            <h4>ยกเลิก</h4>
          </Button>
        </div>
      </Modal>

      {/* Modal 3: Success Dialog */}
      <Modal toggle={() => setModalSuccess(false)} isOpen={modalSuccess} centered>
        <div className="modal-header justify-content-center" style={{ borderBottom: "none", paddingTop: "24px" }}>
          <i className="fas fa-check-circle" style={{ color: "#4caf50", fontSize: "3rem" }}></i>
        </div>
        <ModalBody style={{ textAlign: "center", padding: "10px 24px" }}>
          <h3 style={{ fontFamily: '"Sarabun", sans-serif', fontWeight: "bold", color: "#2e7d32", marginBottom: "8px" }}>
            บันทึกสร้างผู้ใช้งานสำเร็จ!
          </h3>
          <p style={{ fontFamily: '"Sarabun", sans-serif', color: "#3C4858", fontSize: "1.05rem", lineHeight: "1.6" }}>
            สร้างบัญชีผู้ใช้งาน <strong style={{ color: "#e91e63" }}>{successInfo?.userName}</strong>
            <br />
            ({successInfo?.fullName}) เรียบร้อยแล้ว
          </p>
          <div
            style={{
              background: "#e8f5e9",
              border: "1px solid #c8e6c9",
              borderRadius: "6px",
              padding: "12px 16px",
              marginTop: "14px",
              fontSize: "0.92rem",
              color: "#2e7d32",
              fontFamily: '"Sarabun", sans-serif',
              display: "flex",
              alignItems: "center",
              gap: "10px",
              textAlign: "left",
            }}
          >
            <i className="fas fa-info-circle" style={{ color: "#4caf50", flexShrink: 0, fontSize: "1.1rem" }}></i>
            <span>สามารถให้ฝ่ายทรัพยากรบุคคลเพิ่มข้อมูลตำแหน่งและสังกัดหน่วยงานในหน้าจัดการข้อมูลเจ้าหน้าที่ได้ทันที</span>
          </div>
        </ModalBody>
        <div className="modal-footer justify-content-center" style={{ borderTop: "none", gap: "12px", paddingBottom: "24px" }}>
          <Button
            color="success"
            onClick={handleResetForm}
            style={{ minWidth: "140px", fontFamily: '"Sarabun", sans-serif' }}
          >
            <i className="fas fa-user-plus" style={{ marginRight: "6px" }}></i>
            <h4>สร้างคนต่อไป</h4>
          </Button>
          <Button
            color="primary"
            onClick={() => history.push("/hr/index")}
            style={{ minWidth: "160px", fontFamily: '"Sarabun", sans-serif' }}
          >
            <i className="fas fa-users" style={{ marginRight: "6px" }}></i>
            <h4>ไปหน้าข้อมูลเจ้าหน้าที่</h4>
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default UserRequest;
